// extracted by mini-css-extract-plugin
export default {"background":"description_background__Tr0JX","wrapper":"description_wrapper__xMTnl","text":"description_text__Zjwbl"};